<template>
  <div class="ArtistStudioPost row">
    <div class="col-md-4">
      <img class="w-full" :src="post.image" />
    </div>
    <div class="col-md-8">
      <h3 class="ArtistStudioPost-Title">
        <a @click.prevent="setSlug(post.slug)" :href="post.path">
          {{ post.title }}
        </a>
      </h3>
      <div class="ArtistStudioPost-Date">
        {{ post.created_at | formatDateMonthYear }}
      </div>
      <div class="ArtistStudioPost-Content" v-html="post.content"></div>
      <div class="ArtistStudioPost-Favourites">
        <div class="flex">
          <div class="w-1/2">
            <div v-if="artist.user_signed_in">
              <a href="" @click.prevent="favouriteStudioPost">
                <span v-show="!favouritedPost">
                  <i class="fal fa-heart"></i>
                </span>
                <span v-show="favouritedPost">
                  <i class="fas fa-heart"></i>
                </span>
              </a>
            </div>
            <div v-else>
              <a href="" data-toggle="modal" data-target="#session-modal">
                <i class="fal fa-heart"></i>
              </a>
            </div>
            <div class="ArtistStudioPost-Favourites-Counter">{{ favouriteCount }} kudos</div>
          </div>

          <div class="ArtistStudioPost-Favourites-Social w-1/2">
            <a class="inline-block mr-5" :href="fbHref">
              <i class="fab fa-facebook-f" />
            </a>
            <a class="inline-block mr-5" :href="twiHref">
              <i class="fab fa-twitter icon-twitter" />
            </a>
            <a class="inline-block mr-5" :href="pinHref">
              <i class="fab fa-pinterest-p" />
            </a>
            <a class="inline-block mr-5" :href="mailHref">
              <i class="far fa-envelope icon-envelope" />
            </a>
          </div>
        </div>
      </div>
      <div class="ArtistStudioPost-Follow mt-10">
        <strong> Get notified when {{ artist.first_name }} uploads new art </strong>
        <ArtistFollowButton class="mt-5" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { inject } from "vue"

const artist = inject("artist")
const setSlug = inject("setStudioPostSlug")
</script>

<script>
import ArtistFollowButton from "./ArtistFollowButton.vue"

export default {
  name: "ArtistStudioPost",
  props: {
    post: {
      type: Object,
      required: true,
      default: {},
    },
  },
  data() {
    return {
      favouriteCount: this.post.favouritesCount,
      favouritedPost: this.post.favourited_by_user,
    }
  },
  methods: {
    favouriteStudioPost() {
      if (!this.favouritedPost) {
        $.post("/api/studio_posts/favourites?studio_post_id=" + this.post.id, {})
        this.favouriteCount += 1
        this.favouritedPost = true
      } else {
        $.ajax({
          url: "/api/studio_posts/favourites?studio_post_id=" + this.post.id,
          type: "DELETE",
        })
        this.favouriteCount -= 1
        this.favouritedPost = false
      }
    },
  },
  computed: {
    subject() {
      return "Head into the artists studio. Read \«" + this.post.title + "\» blog update on Bluethumb."
    },
    fbHref() {
      return (
        "javascript:void(window.open('http://www.facebook.com/sharer.php?u=" +
        this.post.path +
        "',%20'Share%20to%20Facebook','width=600,height=460,menubar=no,location=no,status=no'))"
      )
    },
    twiHref() {
      return (
        "javascript:void(window.open('https://twitter.com/intent/tweet?url=" +
        this.post.path +
        "&text=" +
        this.subject +
        "&via=BluethumbArt',%20'Share%20to%20Twitter','width=600,height=460,menubar=no,location=no,status=no'))"
      )
    },
    pinHref() {
      return (
        "javascript:void(window.open('https://pinterest.com/pin/create/bookmarklet/?media=" +
        this.post.image_share +
        "&url=" +
        this.post.path +
        "&is_video=false&description=" +
        this.subject +
        "',%20'Share%20to%20Pinterest','width=600,height=460,menubar=no,location=no,status=no'))"
      )
    },
    mailHref() {
      return "mailto:?body=" + this.subject + " " + this.post.path + "%0A&subject=" + this.subject
    },
  },
  components: {
    ArtistFollowButton,
  },
}
</script>

<style scoped>
.ArtistStudioPost {
  font-family: "Lato";
}

.ArtistStudioPost-Title {
  font-size: 14px;
  font-weight: bold;
}

@media screen and (max-width: theme("screens.md") - 1px) {
  .ArtistStudioPost-Title {
    font-size: 12px;
  }
}

.ArtistStudioPost-Date {
  margin-top: 10px;
  margin-bottom: 5px;
  color: rgb(162, 148, 148);
}

.ArtistStudioPost-Content {
  font-size: 13px;
  text-align: justify;
}

.ArtistStudioPost-Favourites {
  margin-top: 20px;
  color: #089fd6;
}

.ArtistStudioPost-Favourites svg {
  float: left;
  font-size: 25px;
}

.ArtistStudioPost-Favourites-Counter {
  font-size: 15px;
  padding-top: 2px;
  padding-left: 35px;
}

::v-deep .ArtistStudioPost .ArtistFollowButton {
  font-size: 14px;
}

::v-deep .ArtistStudioPost .ArtistFollowButton-Follow {
  border: 2px solid theme("colors.primary");
  background-color: #fff !important;
  color: theme("colors.primary") !important;
  width: 125px;
  letter-spacing: 2px;
  line-height: 21px;
  font-weight: bold;
  padding: 8px 0;
  font-size: 14px !important;
}

::v-deep .ArtistStudioPost .ArtistFollowButton-Follow:hover {
  color: #fff;
  border: 2px solid theme("colors.primary");
  background-color: theme("colors.primary");
}
</style>
